import React from "react"
import { notify } from "react-notify-toast"
import { Country, State, City }  from 'country-state-city';

import FormField from "../../Components/FormField/FormField"


//redux
import { connect } from "react-redux"
import FormDropdown from "../../Components/FormField/FormDropdown";
import {getCities, getCountries, getRegions} from "../../Helper";
import * as $ from "jquery";
import CheckableButton from "../../Components/CheckableButton/CheckableButton";
import CancelButton from "../../Components/Buttons/CancelButton";

require("./PersonalDetails.css")

const countries = Country.getAllCountries();

class PreferredWorkLocationsForm extends React.Component {
  constructor(props) {
    super(props)
    // console.log(props)

    if (props === null) {
      window.location = "./login"
    }
  }

  render() {
    return (
      <div>
        <div className="row">
          <FormDropdown
            label="Preferred Country 1"
            id="preferred_country1"
            className="col-md-6 px-0 px-md-3"
            required
            value={this.props.state.preferred_country1}
            onChange={this.props.handleStateChange}
          >
            <option value="">Please Choose</option>
            {this.props.state?.countryList ? Object.keys(this.props.state?.countryList).map((country, index) => (
              <option key={index} value={country}>{country}</option>
            )) : null }
          </FormDropdown>

          <FormDropdown
            label="Preferred City 1"
            id="preferred_city1"
            className="col-md-6 px-0 px-md-3"
            required
            value={this.props.state.preferred_city1}
            onChange={this.props.handleStateChange}
          >
            <option value="" hidden>Please Choose</option>
            {
              this.props.state?.cityList
                ? this.props.state?.cityList?.map((city, index) => {
                  return <option value={city} key={index}>{city}</option>
                })
                : null
            }
          </FormDropdown>

          <FormDropdown
            label="Preferred Country 2 (Optional)"
            id="preferred_country2"
            className="col-md-6 px-0 px-md-3"
            value={this.props.state.preferred_country2}
            onChange={this.props.handleStateChange}
            onClick={this.props.handleStateChange}
          >
            <option value="" hidden>Please Choose</option>
            {countries.map((country) => {
              return <option value={country.isoCode}>{country.name}</option>;
            })}
          </FormDropdown>

          <FormDropdown
            label="Preferred City 2 (Optional)"
            id="preferred_city2"
            className="col-md-6 px-0 px-md-3"
            value={this.props.state.preferred_city2}
            onChange={this.props.handleStateChange}
          >
            <option value="" hidden>Please Choose</option>
            {City.getCitiesOfCountry(this.props.state.preferred_country2)?.map((city) => {
              return <option value={city.name}>{city.name}</option>;
            })}
          </FormDropdown>

          <FormDropdown
            label="Preferred Country 3 (Optional)"
            id="preferred_country3"
            className="col-md-6 px-0 px-md-3"
            value={this.props.state.preferred_country3}
            onChange={this.props.handleStateChange}
          >
            <option value="" hidden>Please Choose</option>
            {countries.map((country) => {
              return <option value={country.isoCode}>{country.name}</option>;
            })}
          </FormDropdown>

          <FormDropdown
            label="Preferred City 3 (Optional)"
            id="preferred_city3"
            className="col-md-6 px-0 px-md-3"
            value={this.props.state.preferred_city3}
            onChange={this.props.handleStateChange}
          >
            <option value="" hidden>Please Choose</option>
            {City.getCitiesOfCountry(this.props.state.preferred_country3)?.map((city) => {
              return <option value={city.name}>{city.name}</option>;
            })}
          </FormDropdown>

        {
          !this.props.user?.is_childhood_teacher && <div className="col-md-6 my-3">
          <CheckableButton
            toggle
            id="preferred_online"
            onChange={this.props.handleOnlineCheck}
            checked={this.props.state.preferred_online}
          >
            Display on my Profile that I am interested in online teaching
          </CheckableButton>
        </div>
        }
        </div>
        <div className="row my-3">
          <div className="col">
            <CancelButton
              onClick={this.props.handleClear}
            >
              Clear Settings
            </CancelButton>
          </div>
        </div>
      </div>
    )
  }
}

//Map root state to this component
const mapStateToProps = function (state) {
  return {
    user: state.user.user,
  }
}

export default connect(mapStateToProps)(PreferredWorkLocationsForm)
// export default EmergencyContactForm2;
